import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { SimpleSelect } from 'react-selectize';
import VisibilitySensor from 'react-visibility-sensor';

import config from 'config';

import Button from 'react-bootstrap/lib/Button';
import Col from 'react-bootstrap/lib/Col';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';

import { loadExternalScript } from 'helpers/HelperFunctions';
import { getSubscriptionToken } from 'redux/modules/payments';

import CurrencySelector from 'components/Shared/Selectors/CurrencySelector';
import styles from './PricingBreakdownBuyer.module.scss';

@connect(
  (state) => ({
    loadingSubscriptionToken: state.payments.loadingSubscriptionToken,
    loadedSubscriptionToken: state.payments.loadedSubscriptionToken,
    subscriptionToken: state.payments.subscriptionToken,
  }),
  {
    getSubscriptionToken,
  }
)
export default class PricingBreakdownBuyer extends Component {
  static propTypes = {
    className: PropTypes.string,
    getSubscriptionToken: PropTypes.func,
    gradient: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.oneOf(['left', 'right']),
    ]),
    loadingSubscriptionToken: PropTypes.bool,
    loadedSubscriptionToken: PropTypes.bool,
    subscriptionToken: PropTypes.string,
    submitClass: PropTypes.string,
    submitId: PropTypes.string,
    submitText: PropTypes.string,
    submitLoadingText: PropTypes.string,
    user: PropTypes.object,
  };

  static defaultProps = {
    gradient: false,
    submitClass: 'btn btn-success btn-lg',
    submitId: 'pay-with-stripe-button',
    submitText: 'Sign up to Business',
    submitLoadingText: 'Loading...',
  };

  constructor() {
    super();

    this.state = {
      visible: false,
      billing: 'month',
      currency: { label: 'USD ($)', value: '$' },
      subscriptionToken: '',
      loadingStripe: true,
      loadingError: false,
      loadingSubmit: false,
      stripe: null,
    };
  }

  componentDidMount() {
    if (typeof this.stripe === 'undefined') {
      loadExternalScript('https://js.stripe.com/v3/', [], this.loadStripe());
    }
  }

  componentDidUpdate(prevProps) {
    // If subscriptionToken got returned from Twine API
    if (
      this.props.subscriptionToken !== prevProps.subscriptionToken &&
      this.props.subscriptionToken !== ''
    ) {
      this.stripeRedirect(this.props.subscriptionToken);
    }
  }

  getToken(subscription = 'price_1IlzBKGtQsaKXkHTDJHp80MG') {
    const tokenRequestObject = {
      user_id: this.props.user.id ? this.props.user.id : 'guest',
      plan_id: subscription,
      success_url: `${location.origin}/ats?success-business`,
      cancel_url: `${location.origin}/pricing`,
    };

    this.props.getSubscriptionToken(tokenRequestObject);
  }

  getPrice() {
    if (this.state.currency.value === '$') {
      return { month: '139.99', year: '1399.99', year_month: '116.67' };
    }

    if (this.state.currency.value === '£') {
      return { month: '99.99', year: '999.99', year_month: '83.33' };
    }
  }

  getCurrency() {
    if (this.state.currency.value === '$') {
      return { code: 'usd', symbol: '$' };
    }

    if (this.state.currency.value === '£') {
      return { code: 'gbp', symbol: '£' };
    }
  }

  getSubscription() {
    // const { billing } = this.state; // no current annual plan
    const currencyCode = this.getCurrency().code;

    if (currencyCode === 'gbp') {
      return 'price_1IlzBKGtQsaKXkHTCREkrUjb';
    }

    return 'price_1IlzBKGtQsaKXkHTDJHp80MG';
  }

  static initInterval = null;

  loadStripe() {
    this.setState(
      {
        loadingStripe: false,
      },
      () => this.initStripe()
    );
  }

  initStripe() {
    this.initInterval = setInterval(() => {
      if (!this.loadingStripe && typeof this.stripe === 'undefined') {
        try {
          if (process.env.ENDPOINT_FRONTEND === 'www.twine.net') {
            this.stripe = window.Stripe(config.stripeKey);
          } else {
            this.stripe = window.Stripe(config.stripeDevKey);
          }
        } catch (err) {
          console.log(err);
        }

        if (typeof this.stripe !== 'undefined' && this.stripe) {
          clearInterval(this.initInterval);
        }
      }
    }, 1000);
  }

  async redirectToCheckout(event) {
    if (!this.props.user) {
      window.location.href = '/signin?referer=/pricing';
    } else {
      try {
        this.getToken(this.getSubscription());
      } catch (err) {
        console.log(err);
      }

      event.preventDefault();
      this.setState({ loadingSubmit: true });
    }
  }

  stripeRedirect(token) {
    this.setState({
      subscriptionToken: token,
    });

    const { error } = this.stripe.redirectToCheckout({
      sessionId: this.props.subscriptionToken,
    });
    if (error) {
      console.warn('Error:', error);
      this.setState({
        loadingError: true,
        loadingStripe: false,
      });
    }

    return true;
  }

  render() {
    const { className, gradient, ...rest } = this.props;

    const { visible, billing, currency } = this.state;

    const price = this.getPrice();

    return (
      <VisibilitySensor
        partialVisibility
        delayedCall
        minTopValue={visible ? 0 : 100}
        active={!visible}
        onChange={(isVisible) => this.setState({ visible: isVisible })}
      >
        <div
          className={
            (gradient
              ? styles.gradient +
                ' ' +
                (gradient === 'left'
                  ? styles.gradientLeft
                  : styles.gradientRight)
              : styles.noGradient) + (className ? ' ' + className : '')
          }
          {...rest}
        >
          <div className={styles.container}>
            <Grid>
              <Row>
                <Col
                  xs={12}
                  sm={6}
                  smPush={6}
                  md={5}
                  mdPush={6}
                  lg={4}
                  lgPush={6}
                >
                  <div
                    className={
                      styles.proSection + (visible ? '' : ' ' + styles.hide)
                    }
                  >
                    <Row>
                      <h3
                        className={
                          styles.header +
                          ' ' +
                          styles.pro +
                          (visible ? '' : ' ' + styles.hide)
                        }
                      >
                        Business
                      </h3>
                    </Row>
                    <Row
                      className={
                        styles.section +
                        ' ' +
                        styles.priceSection +
                        (visible ? '' : ' ' + styles.hide)
                      }
                    >
                      <p>
                        {currency.value}
                        <span className={styles.price}>
                          {billing === 'year' ? price.year_month : price.month}
                        </span>{' '}
                        per project
                      </p>
                      <p>
                        {billing === 'year'
                          ? 'Annually recurring fee of ' +
                            currency.value +
                            price.year +
                            ' you can cancel at any time.'
                          : 'Monthly recurring fee for projects that you can cancel at any time.'}
                      </p>
                    </Row>
                    <Row
                      className={
                        styles.section + (visible ? '' : ' ' + styles.hide)
                      }
                    >
                      <p>Managed service.</p>
                      <p>
                        Your dedicated Customer Success rep will assist with
                        project scoping, brief creation and project management.
                      </p>
                    </Row>
                    <Row
                      className={
                        styles.section + (visible ? '' : ' ' + styles.hide)
                      }
                    >
                      <p>
                        {currency.value === '$'
                          ? 'Personalized'
                          : 'Personalised'}{' '}
                        vetting.
                      </p>
                      <p>
                        Our team will manually vet freelancers in line with your
                        specific requirements, however niche they may be.
                      </p>
                    </Row>
                    <Row
                      className={
                        styles.section + (visible ? '' : ' ' + styles.hide)
                      }
                    >
                      <p>Consolidated billing.</p>
                      <p>
                        Need payment terms? We offer invoiced billing to help
                        manage multiple suppliers. This includes VAT or local
                        taxes.
                      </p>
                    </Row>
                    <Row
                      className={
                        styles.section +
                        ' ' +
                        styles.buttonSection +
                        (visible ? '' : ' ' + styles.hide) +
                        ' ' +
                        styles.end
                      }
                    >
                      <div>
                        <input
                          className={this.props.submitClass}
                          type="submit"
                          id={this.props.submitId}
                          onClick={(event) => this.redirectToCheckout(event)}
                          disabled={this.state.loadingSubmit}
                          value={
                            this.state.loadingSubmit &&
                            this.props.submitLoadingText
                              ? this.props.submitLoadingText
                              : this.props.submitText
                          }
                        />
                      </div>
                    </Row>
                  </div>
                </Col>
                <Col
                  className={
                    styles.standardSection + (visible ? '' : ' ' + styles.hide)
                  }
                  xs={12}
                  sm={6}
                  smPull={6}
                  md={5}
                  mdPull={4}
                  lg={4}
                  lgPull={2}
                >
                  <Row>
                    <h3
                      className={
                        styles.header + (visible ? '' : ' ' + styles.hide)
                      }
                    >
                      Standard
                    </h3>
                  </Row>
                  <Row
                    className={
                      styles.section +
                      ' ' +
                      styles.priceSection +
                      (visible ? '' : ' ' + styles.hide)
                    }
                  >
                    <p>
                      {currency.value}
                      <span className={styles.price}>0.00</span> per month
                    </p>
                    <p>
                      Free to start and only pay a Twine service fee when you
                      hire.
                    </p>
                  </Row>
                  <Row
                    className={
                      styles.section + (visible ? '' : ' ' + styles.hide)
                    }
                  >
                    <p>Free to post freelance projects.</p>
                    <p>
                      No upfront cost, just post up your project requirements
                      and vetted freelancers will contact you with their rates.
                    </p>
                  </Row>
                  <Row
                    className={
                      styles.section +
                      ' hidden-xs' +
                      (visible ? '' : ' ' + styles.hide)
                    }
                  >
                    <p>Vetted freelancers.</p>
                    <p>
                      The Twine platform will automatically screen out
                      irrelevant freelancers from applying to your project,
                      saving you time.
                    </p>
                  </Row>
                  <Row
                    className={
                      styles.section + (visible ? '' : ' ' + styles.hide)
                    }
                  >
                    <p>Service fee from 5%.</p>
                    <p>
                      We have a sliding fee based on the lifetime payments to a
                      freelancer on a project, so the more you hire, the less
                      you pay.
                    </p>
                  </Row>
                  <Row
                    className={
                      styles.section +
                      ' ' +
                      styles.buttonSection +
                      (visible ? '' : ' ' + styles.hide) +
                      ' ' +
                      styles.end
                    }
                  >
                    <a href="/post-a-job">
                      <Button
                        bsSize="lg"
                        className={
                          styles.button + (visible ? '' : ' ' + styles.hide)
                        }
                      >
                        Post a project
                      </Button>
                    </a>
                  </Row>
                </Col>
              </Row>
              <Row className={styles.currencySelector}>
                <Col xs={12} sm={6} smPush={3} md={4} mdPush={4}>
                  <div style={{ display: 'inline' }}>Billing currency: </div>
                  <CurrencySelector
                    value={currency}
                    style={{ width: '50%', display: 'inline-block' }}
                    onChange={(input) => this.setState({ currency: input })}
                  />
                </Col>
              </Row>
            </Grid>
          </div>
        </div>
      </VisibilitySensor>
    );
  }
}
